import React, { type JSX } from 'react';
import { IconButton } from '@mui/material';
import { Download } from '@mui/icons-material';
import { toSafeHttpUrl } from 'utils/security';

type DocumentDownloadButtonProps = {
    testId: string;
    url?: string;
    fileName?: string;
};

// Only renders a link for http(s) URLs; any other scheme gets a disabled button with no href.
export const DocumentDownloadButton = ({ testId, url, fileName }: DocumentDownloadButtonProps): JSX.Element => {
    const safeUrl = toSafeHttpUrl(url);
    const onClick = (event: React.MouseEvent): void => event.stopPropagation();

    if (!safeUrl) {
        return (
            <IconButton data-testid={testId} onClick={onClick} disabled>
                <Download />
            </IconButton>
        );
    }

    return (
        <IconButton data-testid={testId} onClick={onClick} download={fileName} href={safeUrl}>
            <Download />
        </IconButton>
    );
};
